import { render } from "./EnviarPropostaCompra.vue?vue&type=template&id=caed8900&scoped=true"
import script from "./EnviarPropostaCompra.vue?vue&type=script&lang=js"
export * from "./EnviarPropostaCompra.vue?vue&type=script&lang=js"

import "./EnviarPropostaCompra.vue?vue&type=style&index=0&id=caed8900&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caed8900"]])

export default __exports__